import TenantPage from 'components/common/TenantPage';
import { useTranslation } from 'react-i18next';
import { IAccessor, ITicket } from 'interfaces';
import toast from 'features/toast';
import { useNavigate } from 'react-router-dom';
import { accessorService } from 'services/api/AccessorService';
import AccessorForm from '../AccessorForm';

const initAccessor: IAccessor = {
  id: null,
  code: null,
  equipment: null,
  description: null,
  serial_number: null
};

export const CreateAccessor = () => {
  const translationPrefix = 'pages.accessories';
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    accessorService.add(values).then((res) => {
      toast.success(t(`${translationPrefix}.success`));
      navigate('../');
    });
  };

  return (
    <TenantPage title={t(`${translationPrefix}.add`)} subtitle="">
      <AccessorForm accessor={initAccessor} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default CreateAccessor;
